export const GET_DOCTORS_PENDING_SH = "GET_DOCTORS_PENDING_SH";
export const GET_DOCTORS_SUCCESS_SH = "GET_DOCTORS_SUCCESS_SH";
export const GET_DOCTORS_FAILURE_SH = "GET_DOCTORS_FAILURE_SH";
export const POST_DOCTOR_SUCCESS_SH = "POST_DOCTOR_SUCCESS_SH";
export const GET_PECIENT_SUCCESS_SH = "GET_PECIENT_SUCCESS_SH";


